angular.module('impactx.cscontract').controller('CSContractBasicListCtrl', [
    '$scope',
    '$redirect',
    '$controller',
    'PartialDialogsService',
    'dataGen',
    'ToastService',
    'selectedListItems',
    'ConfirmationService',
    '$mdDialog',
    'AppConfiguration',
    '$routeParams',
    CSContractBasicListCtrl]);

function CSContractBasicListCtrl($scope, $redirect, $controller, PartialDialogsService, dataGen, ToastService, selectedListItems, ConfirmationService, $mdDialog, AppConfiguration, $routeParams) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractlist');
    var self = this;

    this.delete = function() {
        var temp = {};
        dataGen.postAsForm(temp, {cscId: selectedListItems.getFirstSelectedId()}, "/cscontract/delete").then(function() {
            mainCtrl.meta.refreshListData({unselectRow: selectedListItems.getFirstSelectedItem()});
            ToastService.openStandardToast(temp.trns.deleteSuccess);
        });
    };

    this.deleteDialog = function(event, trns) {
        ConfirmationService.showConfirmationDialog(self.delete, event, trns.confirmDelete,
            trns.delete, trns.abort);
    };

    this.canDelete = function () {
        return selectedListItems.isSingleSelection() && !impactX.isDefined(selectedListItems.getFirstSelectedItem(), "deleted")
            && !impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMDM.value");
    };

    this.copyContract = function(event, trns) {
        $mdDialog.show({
            controller: "ContractCompanySelectionDialogCtrl",
            controllerAs: "contractCompanySelectionDialogCtrl",
            templateUrl: "modules/cscontract/templates/cscontracompanyselection.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: trns.copyContract,
                cscId: selectedListItems.getFirstSelectedItem().id
            }
        })
            .then(function(answer) {
                const params = {
                    cscId: selectedListItems.getFirstSelectedItem().id,
                    buyerComId: answer.buyerComId,
                    supplierComId: answer.supplierComId,
                    catalogId: answer.catalogId,
                    contactBuyerId: answer.contactBuyerId,
                    copyConfiguration: answer.copyConfiguration
                };
                dataGen.postAsForm({}, params, "/cscontract/copy").then(function (data) {
                    if(data.data.id > 0)
                    {
                        $redirect.redirectTo(null, "/cscmain/" + data.data.id);
                    }
                });
            }, function() {
            });
    };

    this.canCopy = function () {
        return selectedListItems.isSingleSelection();
    };

    var buttonDefinition = mainCtrl.buttonDefinition;
    buttonDefinition.push({label: "delete", action: self.deleteDialog, condition: self.canDelete, process: 'EditCSC'});
    if(!AppConfiguration.get("lotAvailable")) {
        buttonDefinition.push({label: "copyContract", action: self.copyContract, condition: self.canCopy, process: 'EditCSC'});
    }

    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/list',
        ctrl: mainCtrl,
        id: "cscontractlist",
        buttonDefinition: buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: 0},
                {param: 'TenderId', intValue: 0}]
        },
        mainActionFunction : {id:"new", action: mainCtrl.createContract, icon:"mdi-plus"},
        isSelectAble: true,
        valuesInteger: [{name: "CSC_Id", value: $routeParams.preSetId ? $routeParams.preSetId : 0}]
    };
    this.getMeta = function ()
    {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "basic";
    $scope.$watch(function() {
        return mainCtrl.contractType;
    }, function(newValue) {
        if(newValue == "model") {
            $redirect.redirectTo(null, "/cscontractmodellist");
        }
    });
}